import View from '../View';
import { breakpoint } from '../utils/dom';
import 'gsap/TweenMax';

require('waypoints/lib/noframework.waypoints.min');

/**
 * Header
 */
class Header extends View {
  /**
   * Header constructor
   * @param node
   */
  constructor (node) {
    super(node);

    this.topElement = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || window.navigator.userAgent.indexOf('Edge') > -1 ? document.querySelector('body') : document.documentElement;

    this.menuToggle = this.node.querySelector('.js-menu-toggle');
    this.searchClose = this.node.querySelector('.js-menu-close');
    this.searchToggle = this.node.querySelector('.js-search-toggle');
    this.mainMenu = this.node.querySelector('.js-main-menu');
    this.searchMenu = this.node.querySelector('.js-search-menu');

    //Get all the clickable links with submenu in the Header
    this.subMenuLinks = Array.from(this.node.querySelectorAll('.js-submenu-toggle'));

    //If we have links, attach an event listener to all of them
    if (this.subMenuLinks) {
      this.subMenuLinks.forEach((link) => {
        link.addEventListener('click', this.toggleSubMenu);
      });
    }

    //on click menu toggle open main menu
    this.menuToggle.addEventListener('click', (e) => {
      //only on screens smaller than large
      if (breakpoint('large-down')) {
        this.toggleMainMenu(e);
      }
    });

    //on click search toggle open search menu
    this.searchToggle.addEventListener('click', (e) => {
        this.toggleSearchMenu(e);
    });

    //on click menu toggle closed search menu
    this.searchClose.addEventListener('click', () => {
        this.closeSearchMenu();
    });

    this.makeHeaderSticky();

  }

  /**cd _s
   * Make the header sticky
   */
  makeHeaderSticky = () => {
    new Waypoint({
      element: this.topElement,
      handler: function () {
        this.node.classList.toggle('visible');
        document.body.classList.toggle('sticky-header');
        events.emit('stickyHeaderToggle');
      }.bind(this),
    });
  };

  //On small screens > toggle tool buttons open & closed§
  toggleSubMenu = (e) => {
    if (!e.currentTarget.classList.contains('open')) {
      this.openSubMenu(e);
    } else {
      this.closeSubMenu(e);
    }
  };

  /**
   * Toggle submenu open/closed after click (only on smaller screens)
   * @param e
   */
  openSubMenu = (e) => {
    //only on screens smaller than large
    if (breakpoint('large-down')) {
      this.subMenu = e.currentTarget.nextSibling.nextElementSibling;

      //animate open submenu
      TweenMax.set(this.subMenu, {
        height: 'auto',
      });
      TweenMax.from(this.subMenu, 0.5, {
        height: 0,
        ease: Power3.easeInOut,
      });

      e.currentTarget.classList.add('open');
      this.subMenu.classList.add('open');
    }
  };

  /**
   * Toggle submenu open/closed after click (only on smaller screens)
   * @param e
   */
  closeSubMenu = (e) => {
    //only on screens smaller than large
    if (breakpoint('large-down')) {
      this.subMenu = e.currentTarget.nextSibling.nextElementSibling;

      //animate closed submenu
      TweenMax.set(this.subMenu, {
        height: 'auto',
      });
      TweenMax.to(this.subMenu, 0.5, {
        height: 0,
        ease: Power3.easeInOut,
      });

      e.currentTarget.classList.remove('open');
      this.subMenu.classList.remove('open');
    }
  };

  /**
   * Open main menu (only on smaller screens)
   * @param e
   */
  toggleMainMenu = (e) => {
    if (e.currentTarget.classList.contains('active')) {
      e.currentTarget.classList.remove('active');
      this.mainMenu.classList.remove('open');
    } else {
      e.currentTarget.classList.add('active');
      this.mainMenu.classList.add('open');
    }
  };

  /**
   * Open search menu  (only larger screens)
   * @param e
   */
  toggleSearchMenu = (e) => {
    this.searchMenu.classList.toggle('open');

    //Focus on the query input
    if (this.searchMenu.classList.contains('open')) {
      let inputToFocusOn = this.searchMenu.querySelector('.search-input');

      if (inputToFocusOn) {
        window.setTimeout(
          function () {
            let length = inputToFocusOn.value.length;
            // inputToFocusOn.focus();
            inputToFocusOn.setSelectionRange(length, length);
          },
          100,
        );
      }
    }
  };

  /**
   * Close main menu (only on smaller screens)
   */
  closeMainMenu = () => {
    this.mainMenu.classList.remove('open');
  };

  /**
   * Close search menu (only larger screens)
   */
  closeSearchMenu = () => {
    this.searchMenu.classList.remove('open');
  };

}

export default Header;



// WEBPACK FOOTER //
// frontend/js/components/Header.js